export default __webpack_public_path__ + "static/media/notification.b6b30011.svg";